<template>
    <div>
        <section class="map">
            <div id="map"></div>         
        </section>   
    </div>
</template>
<script>
    import { Loader, LoaderOptions } from 'google-maps';    
    import MarkerClusterer from "@google/markerclustererplus"
    import places_json from './places.json'

    export default {
        name: 'MapBlock', 
        mounted () {            
             this.initMap();             
        },  
        data () {
            return {
                places: places_json,
                map_markers: [],
            }
        },    
        methods: {
            initMap () { 
                const options = LoaderOptions;
                const loader = new Loader('AIzaSyCvxk7tbe37q4gKp-mAPFTSpSpBS-6hLAA', options);
                
                let thiss = this;
                loader.load().then(function (google) {                                        
                    const gmap = new google.maps.Map(document.getElementById('map'), { 
                        center: { lat: 50.087810, lng: 14.420460 },
                        zoom: 8,
                    });

                    var infowindow = new google.maps.InfoWindow(), marker, i;

                    //make markers
                    for (let i = 0; i < thiss.places.length; i++) {
                        let marker = null;                        
                        marker = new google.maps.Marker({
                            position: new google.maps.LatLng(thiss.places[i].gps_lat, thiss.places[i].gps_long),
                            map: gmap,
                            animation: google.maps.Animation.DROP,
                            icon: "/img/map/marker.svg",
                        });         

                        google.maps.event.addListener( marker, 'click', ( function ( marker, i ) {
                            return function () {
                                infowindow.setContent( "<b>"+thiss.places[i].name +"</b>" + "<br>" + thiss.places[i].street + ", " + thiss.places[i].city_name );
                                infowindow.open( gmap, marker );
                            }
                        })( marker, i ));

                        google.maps.event.addListener( gmap, 'click', ( function ( marker, i ) {
                            return function () {                                
                                infowindow.close( gmap, marker );
                            }
                        })( marker, i ));

                        google.maps.event.addListener( infowindow, 'closeclick', ( function ( marker, i ) {
                            return function () {                                
                                infowindow.close( gmap, marker );
                            }
                        })( marker, i ));

                        thiss.map_markers.push( marker );
                    }

                    const markerClusterer = new MarkerClusterer(gmap, thiss.map_markers, { imagePath: "/img/map/mk" });
                });
            },
        },
    }
</script>
